import { ProfessionalAthlete } from 'models/interfaces/professional-athlete.interface'
import { PROFESSIONAL_ATHLETE_SELECTED } from './storageConfig'

export function setProfessionalAthleteSelected (professionAthlete: ProfessionalAthlete) {
  sessionStorage.setItem(PROFESSIONAL_ATHLETE_SELECTED, JSON.stringify(professionAthlete))
}

export function getProfessionalAthleteSelected () {
  const strValue = sessionStorage.getItem(PROFESSIONAL_ATHLETE_SELECTED)
  return strValue ? JSON.parse(strValue) as unknown as ProfessionalAthlete : null
}
